import {Alert, Button, Stack} from "@mui/material";
import {useLocalization, useWordingFlavor} from "@smalox/shared";
import {BreadcrumbItem, BreadcrumbLink, Breadcrumbs, Tabs} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {Link, useLocation} from "react-router-dom";
import {useTenantUserApi} from "../../api";
import {useTenantPermission} from "../../tenant";
import {useSearchParam} from "../../utils/search";
import {useParam} from "../../utils/useParam";
import {View, ViewHeader} from "../View";
import {UserAuditTimeline} from "./UserAuditTimeline";
import {UserBookingList} from "./UserBookingList";
import {UserGroupList} from "./UserGroupList";

export function UserView() {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	const username = useParam("username");
	const {getUser} = useTenantUserApi();
	const location = useLocation();
	const addedFromOtherTenant = (location.state as { addedFromOtherTenant?: boolean } | null)?.addedFromOtherTenant;

	const {loading, error, result} = useAsync(getUser, [username]);

	const [tab, setTab] = useSearchParam("tab", "bookings");

	const canEdit = useTenantPermission("TENANT_USER_EDIT");
	const canCreateBooking = useTenantPermission("BOOKING_CREATE");

	return (
		<View loading={loading} error={error}>
			<Breadcrumbs>
				<BreadcrumbLink component={Link} to="..">{t("users.title")}</BreadcrumbLink>
				<BreadcrumbItem>{username}</BreadcrumbItem>
			</Breadcrumbs>
			<ViewHeader
				title={result?.user.displayName ?? ""}
				subTitle={result?.user.email}
				actions={
					<Stack direction="row" spacing={2}>
						{canCreateBooking && (
							<Button
								color="primary"
								variant="contained"
								component={Link}
								to={`../../bookings/new?user=${result?.user.username}`}
							>
								{t(`bookings.create.title.${wordingFlavor}`)}
							</Button>
						)}
						{canEdit && (
							<Button
								color="primary"
								variant="outlined"
								component={Link}
								to={"edit"}
							>
								{t("users.edit.title")}
							</Button>
						)}
					</Stack>
				}
			/>
			{addedFromOtherTenant && <Alert severity="info">{t("users.create.emailPrompt.addedFromOtherTenant")}
			</Alert>}
			<Tabs
				value={tab}
				onChange={(_, tab) => setTab(tab)}
				items={[
					{label: t(`bookings.title.${wordingFlavor}`), value: "bookings"},
					{label: t("groups.title"), value: "groups"},
					{label: t("audit.title"), value: "audit"},
				]}
			/>
			{tab == "bookings" && <UserBookingList />}
			{tab == "groups" && <UserGroupList />}
			{tab == "audit" && <UserAuditTimeline />}
		</View>
	);
}
